// @flow

import React, { type Node } from 'react';
import { clamp } from 'lodash';

import {
  type HeadingLevelContextType,
  HeadingLevelProvider,
  useHeadingLevel,
} from '@zapier/common-utils';

type FACC = (props: HeadingLevelContextType) => Node;

type LevelComponentProps = {
  children: FACC | Node,
};

const HeadingLevel = ({ children }: LevelComponentProps) => {
  const { level } = useHeadingLevel();
  const nextLevel = clamp(level + 1, 1, 6);
  if (level < 0) {
    console.warn(
      `You provided a negative level value of ${level}. Please ensure that the first level is a positive number.`
    );
  }
  return (
    <HeadingLevelProvider level={nextLevel}>
      {typeof children === 'function'
        ? children({ level: nextLevel })
        : children}
    </HeadingLevelProvider>
  );
};

export default HeadingLevel;
